export default __webpack_public_path__ + "static/media/point.5cd41921.svg";